import { DefaultCarPageComponentProps } from "@/app/interface/components";
import ContactForm from "../../ContactForm/ContactForm";
import CarOverview from "./CarOverview";
import TechSpecsMobile from "./TechSpecsMobile";

export default function CarDatasheetMobile({
  ...props
}: DefaultCarPageComponentProps) {
  return (
    <>
      <div className="bg-neutral-100 flex flex-col items-center justify-center">
        <CarOverview {...props} />
        <TechSpecsMobile {...props} />
        <ContactForm options={props.model?.versions?.map((v) => v.name)} />
      </div>
    </>
  );
}
